// extracted by mini-css-extract-plugin
export default {"RemoveVideoButton":"_RemoveVideoButton--OVen_"};